/* ----------------------------

Legacy Content Manipulation and Fixes

---------------------------- */

jQuery(document).ready(function($) {
     
    // Wrap legacy article videos with our responsive video wrappers
	//----------------------------------------------
    $('iframe.video_16_9, iframe.video_4_3').each(function(){
        
        $(this).attr('frameborder', '0').next('br').remove();
        
        var $parent = $(this).parent();
        
        if ($parent.is('p')) {
           
            $(this).insertBefore($(this).parent()).wrap('<div class="video-embed size-full align-none"></div>');
            
            if ($(this).parent().next('p').html().replace(/\s|&nbsp;|\u200B/g, '').length == 0) {
                $(this).parent().next('p').remove();
            }
            
        } else if ($parent.is('span')) {
            
            $(this).unwrap().insertBefore($(this).parent()).wrap('<div class="video-embed size-full align-none"></div>');
            
            if ($(this).parent().next('p').html().replace(/\s|&nbsp;|\u200B/g, '').length == 0) {
                $(this).parent().next('p').remove();
            }
            
        } else {
	        
            $(this).wrap('<div class="video-embed size-full align-none"></div>');
            
        }
        
    });
    
    // Azure Blob Storage transfer image fix
    $('.article-content--body img').each(function() {
	    
	    var img = $(this).attr('src');
	    var elon_path = 'www.elon.edu/u/wp-content/uploads/sites/';
	    var azure_path = 'eloncdn.blob.core.windows.net/eu3/sites/';
	    
	    if (img.indexOf(elon_path) !== -1) {
		
			var new_img = img.replace(elon_path, azure_path);
			$(this).attr('src', new_img);
		   
		}
	    
    });
	
});